declare global {
  interface Window {
    DerechRecognition?: { transcribe(wav: string, signal: AbortSignal): Promise<string>; cancel(): void };
  }
}

/** Reuse the bounded recording; never ask a second recognizer to capture over music. */
export async function recognizeOnDevice(audio: Blob, signal: AbortSignal): Promise<string> {
  if (!window.DerechRecognition) throw new Error("Native recognition unavailable");
  signal.throwIfAborted();
  const context = new AudioContext();
  try {
    const decoded = await context.decodeAudioData(await audio.arrayBuffer());
    if (decoded.duration <= 0 || decoded.duration > 30) throw new Error("Recording is too long");
    const frames = Math.ceil(decoded.duration * 16000);
    const offline = new OfflineAudioContext(1, frames, 16000);
    const source = offline.createBufferSource(); source.buffer = decoded; source.connect(offline.destination); source.start();
    const samples = (await offline.startRendering()).getChannelData(0);
    signal.throwIfAborted();
    const bytes = new Uint8Array(44 + samples.length * 2), view = new DataView(bytes.buffer);
    const word = (offset: number, text: string) => [...text].forEach((c, i) => { bytes[offset + i] = c.charCodeAt(0); });
    word(0, "RIFF"); view.setUint32(4, bytes.length - 8, true); word(8, "WAVEfmt ");
    view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
    view.setUint32(24, 16000, true); view.setUint32(28, 32000, true); view.setUint16(32, 2, true); view.setUint16(34, 16, true);
    word(36, "data"); view.setUint32(40, bytes.length - 44, true);
    samples.forEach((value, i) => { const sample = Math.max(-1, Math.min(1, value)); view.setInt16(44 + i * 2, Math.round(sample * (sample < 0 ? 32768 : 32767)), true); });
    let binary = "";
    for (let i = 0; i < bytes.length; i += 8192) binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
    return await window.DerechRecognition.transcribe(btoa(binary), signal);
  } finally { await context.close(); }
}
